/* unplugin-vue-components disabled */
import {PulseInput, PulseSearch} from 'components/pulse'
import PulseButton from '../pulse-button.vue'
import Rest from 'utils/rest'
import {API2_PULSE} from 'consts/api2'
import {TRACKER_TYPES} from 'consts/ttypes'
import {markRaw} from 'vue'

export default {
  components: {PulseInput, PulseButton, PulseSearch},
  props: {
  },
  emits: ['apply'],
  data() {
    return {
      head_text: undefined,
      rest: new Rest(),
      show: false,
      search: '',
      chosen: new Set(),
      type: undefined,
      entities: [],
      total_types: [],
      loading: false,
      snapshot: new Set(),


      tracker_types: markRaw(TRACKER_TYPES)
    }
  },
  computed: {
    changed() {
      return $utils.array.serialize(this.snapshot) !== $utils.array.serialize(this.chosen)
    },
    empty(){
      return !this.entities.length
    },
    filters() {
      return [this.type, this.search]
    },
    can_clear(){
      return this.search || this.type || this.chosen.size
    }
  },
  watch: {
    filters(val){
      if(!val) this.loadItems()
      else this.$debounce_500(this.loadItems)
    },
  },
  async mounted() {
    this.setHeadText()
    await this.loadItems()
    this.total_types = this.entities.map(x => x.type) //TODO need to get this count from server
  },
  beforeUnmount() {
    this.abortAll()
  },
  methods: {
    getType(val) {
      return this.tracker_types.find(x => x.value === val)
    },
    abortAll() {
      this.rest.abortAll()
    },
    setHeadText(){
      this.head_text = this.chosen.size 
        ? $utils.str.pluralize(this.chosen.size, 'Tracker', 'Trackers') : 'All Trackers'
    },
    async loadItems() {
      this.loading = true
      this.rest.abortAll()
      this.entities = await this.rest.get(`${API2_PULSE}/entities`, 
        {type: this.type, search: this.search}
      )
      this.loading = false
    },
    apply() {
      this.show = false
      this.setHeadText()
      this.$emit('apply', Array.from(this.chosen))
      this.snapshot = new Set(this.chosen)
    },
    clearFilters(){
      this.search = ''
      this.type = undefined
    },
    clearAll() {
      this.clearFilters()
      this.chosen.clear()
      this.apply()
    },
    async setEntity(id){
      if (!this.entities.some(item => item.id === id)) {
        await this.loadItems()
      }
      this.chosen.clear()
      this.chosen.add(id)
      this.apply()
    },
    calcCount(type) {
      return this.total_types.filter(t => t === type).length
    }
  }
}
